import React, { createContext, useContext, useEffect, useState } from 'react'
import { me as fetchMe } from '../services/auth'

type AuthContextValue = {
  user: any | null
  loading: boolean
  refresh: (force?: boolean) => Promise<void>
  setUser: (u: any | null) => void
}

const AuthContext = createContext<AuthContextValue | undefined>(undefined)

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<any | null>(null)
  const [loading, setLoading] = useState(true)

  const refresh = async (force = false) => {
    setLoading(true)
    try {
      const u = await fetchMe(force).catch(() => null)
      setUser(u ?? null)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    // نحمّل بيانات المستخدم مرة عند mount
    refresh(false)
    // لا حاجة لفِترات أو polling — كل تحديث يتم عبر الأحداث أو استدعاء refresh()
    // إذا أردت background refresh كل X ثانية، ضع interval هنا (ليس مستحسناً الآن)
  }, [])

  return (
    <AuthContext.Provider value={{ user, loading, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within AuthProvider')
  return ctx
}

